"use strict";
var isSet = function(value) {
  return (typeof value != 'undefined' && value != null);
};
var isDefined = function(value) {
  return (typeof value != 'undefined');
};
var hasPermission = function(permissions, permission) {
  if (typeof permissions == 'undefined' || permissions == null) {
    return false;
  }
  var index = permissions.indexOf(permission);
  if (index > -1) {
    return true;
  }
  return false;
};
module.exports = {
  isSet: isSet,
  isDefined: isDefined,
  hasPermission: hasPermission
};
